import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Button} from 'ui-library';
import i18n from 'i18n';

import {cancelInvitation} from 'redux/modules/brands';
import {
  hideModal,
  resetRequest,
  sendRequest,
  showAlert
} from 'redux/modules/app';

import {getRequest} from 'modules/shared/selectors';

import Dialog from 'modules/legacy/js/components/dialog';

function mapStateToProps(state) {
  return {
    request: getRequest(state, 'cancelBrandInvitation')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    cancelInvitation,
    hideModal,
    resetRequest,
    sendRequest,
    showAlert
  }, dispatch);
}

const Confirmation = createClass({
  propTypes: {
    brandUser: PropTypes.object.isRequired,
    request: PropTypes.object,
    onSuccess: PropTypes.func,
    cancelInvitation: PropTypes.func,
    resetRequest: PropTypes.func,
    sendRequest: PropTypes.func,
    showAlert: PropTypes.func,
    hideModal: PropTypes.func
  },

  onRemoveSuccess() {
    const {showAlert, hideModal, brandUser, onSuccess} = this.props;

    if (onSuccess) onSuccess();
    hideModal();
    showAlert({
      type: 'success',
      message: i18n.get('ADV_BRANDS_USER_INVITE_DELETE_REMOVE_SUCCESS_ALERT_MESSAGE', {
        userEmail: brandUser.email
      })
    });
  },

  onRemoveFail() {
    this.props.showAlert({
      type: 'error',
      message: i18n.get('ADV_BRANDS_USER_INVITE_DELETE_REMOVE_ERROR_ALERT_MESSAGE')
    });
  },

  remove() {
    const {brandUser, cancelInvitation} = this.props;
    const args = {
      brandUserId: brandUser.id,
      brandId: brandUser.brandId,
      email: brandUser.email
    };

    cancelInvitation(args)
      .then(this.onRemoveSuccess)
      .catch(this.onRemoveFail);
  },

  render() {
    const {brandUser, hideModal, request} = this.props;
    const isLoading = request.status === 'loading';
    const content = (
      <div className='padding-2x'>
        <h5 className='vf-font-normal'>
          {i18n.get('ADV_BRANDS_USER_INVITE_DELETE_DESCRIPTION')}
          {' '}
          <b>{brandUser.email}</b>.
          <p className='margin-top-Hx'>
            {i18n.get('ADV_BRANDS_USER_WISH_TO_CONTINUE')}
          </p>
        </h5>

        <div className='flex width100 end-xs margin-top-2x'>
          <Button className='margin-right-Hx' onClick={hideModal}>
            {i18n.get('ADV_BRANDS_USER_CLOSE')}
          </Button>

          <Button
            className='margin-right-Hx'
            color='danger'
            disabled={isLoading}
            onClick={this.remove}
          >
            {isLoading
              ? i18n.get('ADV_BRANDS_USER_INVITE_DELETE_CANCELING_INVITE')
              : i18n.get('ADV_BRANDS_USER_INVITE_DELETE_CANCEL_INVITE')
            }
          </Button>
        </div>
      </div>
    );

    return (
      <Dialog
        size='sm'
        header={i18n.get('ADV_BRANDS_USER_CARD_ROW_WARNING_HEADER')}
        content={content}
        onClose={hideModal}
      />
    );
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);
